module.exports = require("querystring");


//////////////////
// WEBPACK FOOTER
// external "querystring"
// module id = 138
// module chunks = 0 1 2 3